import { Box, Checkbox, FormControl, FormControlLabel, TextField } from '@mui/material';
import { FC, useState } from 'react';
import { CountrySelectMenu } from 'ui/CountrySelectMenu';
import { errorsTableStructure } from 'components/ErrorsCorrections/ErrorsTable/errors-table-structure';
import { useParams } from 'react-router';
import { TTableStructure } from 'components/ErrorsCorrections/ErrorsTable/types';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'redux/reducers/user/selectors';
import { getErrorCorrection } from 'redux/reducers/errorCorrections/selectors';
import { TStep2Props } from './types';

export const Step2: FC<TStep2Props> = ({
	selectedScript,
	errorParams,
	handleScriptParametersChange,
}) => {
	return (
		<Box>
			<FormControl
				sx={{
					width: '100%',
				}}
			>
				{errorParams.length > 0 &&
					errorParams?.map((param, index) => {
						if (param.type === 'country-code')
							return (
								<CountrySelectMenu
									onChange={value => handleScriptParametersChange(index, value)}
									countryCode={errorParams[index].value ?? ''}
									label={errorParams[index].name ?? ''}
								/>
							);
						if (param.type === 'boolean')
							return (
								<FormControlLabel
									control={
										<Checkbox
											checked={errorParams[index].value as boolean}
											onChange={e => handleScriptParametersChange(index, e.target.checked)}
											color="primary"
										/>
									}
									label={param.name}
								/>
							);

						return (
							<TextField
								key={param.name}
								value={errorParams[index].value}
								label={param.name}
								onChange={e => handleScriptParametersChange(index, e.target.value)}
								size="small"
								margin="normal"
								sx={{
									borderRadius: '12px',
									margin: '10px 0',
									'& .MuiInputBase-root': {
										borderRadius: '12px',
									},
								}}
							/>
						);
					})}
			</FormControl>
		</Box>
	);
};
